import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-navy text-white pt-16 pb-20 px-6 md:pt-24 md:pb-32 overflow-hidden relative" data-id="element-100">
      {/* Subtle background anchor motif */}
      <div className="absolute top-[-10%] right-[-10%] opacity-5 pointer-events-none" data-id="element-101">
        <svg width="400" height="400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-102">
          <circle cx="12" cy="5" r="3" data-id="element-103" />
          <line x1="12" y1="22" x2="12" y2="8" data-id="element-104" />
          <path d="M5 12H2a10 10 0 0 0 20 0h-3" data-id="element-105" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col space-y-6" data-id="element-107">
          <div className="inline-block bg-teal/20 text-teal-100 px-4 py-1.5 rounded-full text-sm font-medium tracking-wide border border-teal/30 w-fit" data-id="element-108">
            NUEVO LANZAMIENTO
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-white" data-id="element-109">
            Detén los Meltdowns Sensoriales de tu Hijo en Menos de 5 Minutos
          </h1>

          <h2 className="text-xl md:text-2xl text-copper font-medium font-serif italic" data-id="element-110">
            Sin gritos, culpa ni agotamiento extremo
          </h2>

          <p className="text-base md:text-lg text-gray-300 leading-relaxed max-w-xl" data-id="element-111">
            Una guía práctica en español para acompañarte en momentos intensos
            con más calma, claridad y seguridad, ya sea en casa o fuera de ella.
          </p>

          <div className="pt-6" data-id="element-112">
            <a href="#comprar" className="inline-block w-full md:w-auto text-center bg-copper hover:bg-[#b86a3d] text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(201,123,75,0.4)]" data-id="element-113">
              ¡SÍ, QUIERO EL PROTOCOLO SOS AHORA!
            </a>
            <p className="text-sm text-gray-400 mt-3 text-center md:text-left flex items-center justify-center md:justify-start gap-2" data-id="element-114">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-115">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-116"></path>
              </svg>
              Acceso digital inmediato
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-117">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-white/10" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/18Q3yTHNzMhucuupEvJ1g4/imagen_1.png" alt="Guía SOS de Calma - Recurso práctico para momentos intensos" className="w-full h-auto object-cover" data-id="element-119" />
          </div>
        </motion.div>
      </div>
    </section>;
}